<script setup lang="ts">
import BaseLayout from "./base.vue";
// TODO: this layout is a quick fix for the bug, it will be refactored into a more complex layout system later
</script>

<template>
  <base-layout>
    <template #header>
      <import-header>
        <slot name="header">
          <layout-dynamic-region region="header" classes="contents empty:block" />
        </slot>
      </import-header>
    </template>

    <template #mainContent>
      <main class="bg-ngray-6 w-full px-6 pt-4 flex flex-col gap-4">
        <slot />
      </main>
    </template>

    <template #footer>
      <version-footer />
    </template>
  </base-layout>
</template>
